// Iter149 · Helper único de visibilidad de módulos por empresa.
// Regla: un módulo es visible si:
//   1) Está en `plan_modulos` (permiso duro del plan SaaS), Y
//   2) Está en `MODULOS_POR_ROL[rol]` (rol interno del workspace), Y
//   3) Si la empresa tiene preferencia `modulos_visibles`, además debe estar ahí.
// Si `modulos_visibles` no está definida (null/undefined) o es una lista vacía → se
// respeta el comportamiento actual (mostrar todo lo permitido por plan ∩ rol).
// El módulo "resumen" SIEMPRE es visible.

const SIEMPRE_VISIBLES = new Set(["resumen"]);

export function isModuloVisible(moduloKey, user) {
  if (!moduloKey) return true;
  if (SIEMPRE_VISIBLES.has(moduloKey)) return true;
  if (!user) return true; // sin sesión, no bloqueamos por UI
  // Superadmin de plataforma ve todo
  if (user.role === "superadmin") return true;
  // Capa A · Permiso duro del plan
  const planModulos = user.plan_modulos;
  if (Array.isArray(planModulos) && planModulos.length > 0 && !planModulos.includes(moduloKey)) return false;
  // Capa B · Rol interno (viene precomputado como modulos_rol o modulos_efectivos)
  const modulosRol = user.modulos_rol || user.modulos_efectivos;
  if (Array.isArray(modulosRol) && modulosRol.length > 0 && !modulosRol.includes(moduloKey)) return false;
  // Capa C · Preferencia visual de la empresa
  const mv = user.modulos_visibles;
  if (Array.isArray(mv) && mv.length > 0 && !mv.includes(moduloKey)) return false;
  return true;
}

export function useModulosVisibles(user) {
  return {
    isVisible: (m) => isModuloVisible(m, user),
    filter: (list, getKey = (x) => x.key || x.modulo) => (list || []).filter((it) => isModuloVisible(getKey(it), user)),
  };
}
